export const MANAGE_MASTER_SET_FLOW = "managemaster/SET_FLOW";
export const MANAGE_MASTER_SET_SELECTED_MENU = "managemaster/SET_SELECTED_MENU";
export const MANAGE_MASTER_SET_TOAST_INFO = "managemaster/SET_TOAST_INFO";
export const MANAGE_MASTER_LOCAL_CACHE = "managemaster/LOCAL_CACHE";
export const MANAGE_MASTER_CLEAR_LOCAL_CACHE = "managemaster/CLEAR_LOCAL_CACHE";
export const MANAGE_MASTER_POST_API_ERROR = "managemaster/POST_API_ERROR";
export const MANAGE_MASTER_INNER_DETAILS = "managemaster/INNER_DETAILS";

export const setManageMasterFlow = (payload) => ({
  type: MANAGE_MASTER_SET_FLOW,
  payload,
});

export const setManageMasterSelectedMenu = (payload) => ({
  type: MANAGE_MASTER_SET_SELECTED_MENU,
  payload,
});

export const setManageMasterToastInfo = (payload) => ({
  type: MANAGE_MASTER_SET_TOAST_INFO,
  payload,
});

export const setManageMasterLocalCache = (payload) => ({
  type: MANAGE_MASTER_LOCAL_CACHE,
  payload,
});

export const clearLocalCacheByModelMaster = (payload) => ({
  type: MANAGE_MASTER_CLEAR_LOCAL_CACHE,
  payload,
});

export const setManageMasterPostApiError = (payload) => ({
  type: MANAGE_MASTER_POST_API_ERROR,
  payload,
});

export const setManageInnerDetails = (payload) => ({
  type: MANAGE_MASTER_INNER_DETAILS,
  payload,
});
